import React, { useEffect } from 'react';
import s from './s.module.less';
import { Input } from 'antd';
import { buildNanpDisplayMask, caretPosAfterDigits, parseNanpChange } from 'components/form/nanpInputMask';

type Props = React.ComponentProps<typeof Input> & {
    value?: string;
    onChange?: (val: string) => void;
    wrapClass?: string;
    size?: 'large' | 'small' | 'middle';
    needDisplay?: boolean;
    disabled?: boolean;
    customPaddingLeft?: number;
};

const UsPhoneInput = (props: Props) => {
    const {
        value,
        onChange,
        size = 'middle',
        needDisplay = true,
        disabled = false,
        customPaddingLeft = 0,
        ...others
    } = props;
    const [val, setVal] = React.useState('');
    const inputRef = React.useRef<HTMLInputElement | null>(null);
    const pendingCaret = React.useRef<number | null>(null);

    useEffect(() => {
        // 存量值超过 10 位时不截断：校验按完整值算，显示也必须完整，用户才能看出存的号码本身不合法
        setVal((value || '').replace(/\D/g, ''));
    }, [value]);

    const format = needDisplay ? buildNanpDisplayMask : (digits: string) => digits;

    React.useLayoutEffect(() => {
        if (pendingCaret.current !== null) {
            inputRef.current?.setSelectionRange(pendingCaret.current, pendingCaret.current);
            pendingCaret.current = null;
        }
    }, [val]);

    return (
        <div className={s.wrap}>
            <Input
                ref={(inputElement) => {
                    inputRef.current = inputElement?.input || null;
                }}
                size={size}
                {...others}
                inputMode="tel"
                autoComplete="one-time-code"
                onChange={(e) => {
                    const el = e.target as HTMLInputElement;
                    const inputType = (e.nativeEvent as InputEvent | undefined)?.inputType;
                    const { digits, digitsBefore } = parseNanpChange(el, inputType, val);
                    const nextDisplay = format(digits);
                    const caretPos = caretPosAfterDigits(nextDisplay, digitsBefore);
                    if (digits !== val) {
                        pendingCaret.current = caretPos;
                        setVal(digits);
                        onChange?.(digits);
                    } else {
                        // 数字没变（如输入了字母、删到格式字符边界）时 React 不会重渲染，手动纠正 DOM
                        if (el.value !== nextDisplay) el.value = nextDisplay;
                        el.setSelectionRange(caretPos, caretPos);
                    }
                }}
                className={others.className}
                style={{
                    ...others.style,
                    ...(customPaddingLeft ? { paddingLeft: 11 + customPaddingLeft } : null),
                }}
                value={format(val)}
                disabled={disabled}
            />
        </div>
    );
};

export default UsPhoneInput;
